export default __webpack_public_path__ + "static/media/bg.73445cb5.png";